import { functions } from "../firebase";

const listUsersCallable = functions.httpsCallable("listUsers");
const setUserAdminCallable = functions.httpsCallable("setUserAdmin");
const createUserCallable = functions.httpsCallable("createUser");
const deleteUserCallable = functions.httpsCallable("deleteUser");

export default {
  getUsers() {
    return listUsersCallable()
      .then((res) => res.data)
      .catch((err) => {
        console.error(err);
        throw err;
      });
  },
  setUserAdmin(targetUid, admin) {
    return setUserAdminCallable({ targetUid, admin })
      .then((res) => res.data)
      .catch((err) => {
        console.error(err);
        throw err;
      });
  },
  createUser(payload) {
    return createUserCallable(payload)
      .then((res) => res.data)
      .catch((err) => {
        console.error(err);
        throw err;
      });
  },
  deleteUser(targetUid) {
    return deleteUserCallable({ targetUid })
      .then((res) => res.data)
      .catch((err) => {
        console.error(err);
        throw err;
      });
  },
};
